<template>
    <div>
        <div v-if="props.question.header != null" class="mb-3">{{ props.question.header[participant.language] }}</div><!-- props.question.text[preferred_language] -->
        <div v-if="props.question.text != null" class="mb-3">{{ props.question.text[participant.language] }}</div><!-- props.question.text[preferred_language] -->
        <div v-for="answer in props.question.answers" :key="answer.value" class="ms-4 mb-4 form-check">
            <input 
                class="form-check-input" 
                type="checkbox" 
                :name="answer.variable" 
                :id="answer.variable +'_'+ answer.value"
                :checked="response[answer.variable] == answer.value"
                @click="response[answer.variable] = isChecked($event); saveResponse()"
            >
            <label 
                class="form-check-label" 
                :for="answer.variable +'_'+ answer.value"
            >
                {{ answer.label[participant.language] }}
            </label>
        </div>
    </div>
</template>


<script setup>
    import { storeToRefs } from 'pinia'
    import { useSurveysStore } from '../../../stores/surveys'

    const { saveResponse } = useSurveysStore()
    const { participant, response } = storeToRefs(useSurveysStore())
    const props = defineProps(['question'])

    function isChecked (e) {
        return e.target.checked ? 1 : null
    }
</script>